module.exports = __webpack_public_path__ + "img/gs.04768ec2.jpg";